import React from 'react';
import { mockData } from '../data/mock';
import { ContactForm } from './contact/ContactForm';
import { ContactInfo } from './contact/ContactInfo';

const Contact = () => (
  <section className="py-24 bg-gradient-to-br from-gray-50 to-cyan-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-16">
        <div className="inline-block px-4 py-2 bg-cyan-100 text-cyan-700 rounded-full text-sm font-medium mb-4">
          Get In Touch
        </div>
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
          Let's Start Your Financial Journey
        </h2>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          Reach out to us for personalized financial solutions and expert guidance
        </p>
        <p className="text-lg text-cyan-600 font-semibold mt-4">
          {mockData.contact.responseTime}
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-12">
        <ContactForm />
        <ContactInfo />
      </div>
    </div>
  </section>
);

export default Contact;
